import Button from "./Button.style";
import Heading from "./Heading.style";
import Input from "./Input.style";
import Popover from "./Popover.style";
import Select from "./Select.style";

const components = {
  Button,
  Heading,
  Input,
  Popover,
  Select
};

export default components;
